import {
    ADD_AUDIENCES,
    AGENDATE_AUDIENCES,
    AGENDATE_AUDIENCES_SUCCESS,
    AGENDATE_AUDIENCES_ERROR,
    ANULATE_ACCUSED_RESULT,
    ANULATE_ACCUSED_RESULT_SUCCESS,
    ANULATE_ACCUSED_RESULT_ERROR,
    ANULATE_AUDIENCE,
    ANULATE_AUDIENCE_SUCCESS,
    ANULATE_AUDIENCE_ERROR,
    APPROVE_AUDIENCE,
    APPROVE_AUDIENCE_SUCCESS,
    APPROVE_AUDIENCE_ERROR,
    CANCEL_AUDIENCE,
    CANCEL_AUDIENCE_SUCCESS,
    CANCEL_AUDIENCE_ERROR,
    CLONE_AUDIENCE,
    CLONE_AUDIENCE_SUCCESS,
    CLONE_AUDIENCE_ERROR,
    DELETE_AUDIENCES,
    DELETE_AUDIENCES_SUCCESS,
    DELETE_AUDIENCES_ERROR,
    EDIT_AUDIENCES,
    FINALIZE_AUDIENCE,
    FINALIZE_AUDIENCE_SUCCESS,
    FINALIZE_AUDIENCE_ERROR,
    GET_AUDIENCE,
    GET_AUDIENCE_SUCCESS,
    GET_AUDIENCE_ERROR,
    LIST_AUDIENCES,
    LIST_AUDIENCES_SUCCESS,
    LIST_AUDIENCES_ERROR,
    REJECT_AUDIENCE,
    REJECT_AUDIENCE_SUCCESS,
    REJECT_AUDIENCE_ERROR,
    RESERVE_AUDIENCE,
    RESERVE_AUDIENCE_SUCCESS,
    RESERVE_AUDIENCE_ERROR,
    REVOKE_AUDIENCE,
    REVOKE_AUDIENCE_SUCCESS,
    REVOKE_AUDIENCE_ERROR,
    ROLLBACK_AUDIENCE,
    ROLLBACK_AUDIENCE_SUCCESS,
    ROLLBACK_AUDIENCE_ERROR,
    SAVE_ACCUSED_RESULT,
    SAVE_ACCUSED_RESULT_SUCCESS,
    SAVE_ACCUSED_RESULT_ERROR,
    SAVE_AUDIENCES,
    SAVE_AUDIENCES_SUCCESS,
    SAVE_AUDIENCES_ERROR,    
    UPDATE_ACCUSED,
    UPDATE_ACCUSED_SUCCESS,
    UPDATE_ACCUSED_ERROR,
    UPDATE_AUDIENCES,
    UPDATE_AUDIENCES_SUCCESS,
    UPDATE_AUDIENCES_ERROR, 
    UPDATE_CANCELLATION,
    UPDATE_CANCELLATION_SUCCESS,
    UPDATE_CANCELLATION_ERROR,
    UPDATE_OFIJU,
    UPDATE_OFIJU_SUCCESS,
    UPDATE_OFIJU_ERROR,
    UPDATE_OPERATOR,
    UPDATE_OPERATOR_SUCCESS,
    UPDATE_OPERATOR_ERROR,
    UPDATE_PROCEEDING,
    UPDATE_PROCEEDING_SUCCESS,
    UPDATE_PROCEEDING_ERROR,   
    UPDATE_PROSECUTOR,
    UPDATE_PROSECUTOR_SUCCESS,
    UPDATE_PROSECUTOR_ERROR,
    UPDATE_SALA,
    UPDATE_SALA_SUCCESS,
    UPDATE_SALA_ERROR,
    UPDATE_SCHEDULED_END,    
    UPDATE_SCHEDULED_END_SUCCESS,    
    UPDATE_SCHEDULED_END_ERROR,
    UPDATE_SESSION_URL,
    UPDATE_SESSION_URL_SUCCESS,
    UPDATE_SESSION_URL_ERROR,
    UPDATE_VICTIM,
    UPDATE_VICTIM_SUCCESS,
    UPDATE_VICTIM_ERROR,
    WORK_LIST_AUDIENCES,
    WORK_LIST_AUDIENCES_SUCCESS,
    WORK_LIST_AUDIENCES_ERROR,
} from '../types';

import {  
    MSG_AGENDATE_SUCCESS, 
    MSG_ANULATE_SUCCESS,
    MSG_ANULATE_ACCUSED_RESULT_SUCCESS,
    MSG_APPROVE_SUCCESS, 
    MSG_CANCEL_SUCCESS, 
    MSG_CLONE_AUDIENCE_SUCCESS, 
    MSG_CREATE_SUCCESS, 
    MSG_DELETE_SUCCESS, 
    MSG_DELETING,  
    MSG_ERROR_AGENDATE_TYPE, 
    MSG_ERROR_SERVER, 
    MSG_FINALIZE_SUCCESS,
    MSG_REJECT_SUCCESS, 
    MSG_RESERVE_SUCCESS,
    MSG_REVOKE_SUCCESS,
    MSG_SAVE_ACCUSED_RESULT_SUCCESS, 
    MSG_UNRESERVE_SUCCESS,  
    MSG_UPDATE_ACCUSED_SUCCESS,
    MSG_UPDATE_OFIJU_SUCCESS,  
    MSG_UPDATE_OPERATOR_SUCCESS, 
    MSG_UPDATE_PROCEEDING_SUCCESS,
    MSG_UPDATE_PROSECUTOR_SUCCESS, 
    MSG_UPDATE_SALA_SUCCESS,
    MSG_UPDATE_SCHEDULED_END_SUCCESS,
    MSG_UPDATE_SESSION_SUCCESS, 
    MSG_UPDATE_SUCCESS, 
    MSG_UPDATE_VICTIM_SUCCESS, 
} from '../constants/messages';

import clienteAxios                                                             from '../config/axios';
import Swal                                                                     from 'sweetalert2';
import { APROBADA, SOLICITUD }                                                  from '../data/audienceStates';
import { ErrorMessage, ErrorMessageWithAction, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { JUDGE_FIXED, JUDGE_INTERVEENING }                                      from '../constants/agendateTypes';
import { PROFILE_OGA, PROFILE_SISTEMAS }                                        from '../data/profiles';

const controller = 'audiencia';
const controllerV2 = 'audiences';




//ADD AUDIENCE
export function addAudiencesAction(showForm) {
    return (dispatch) => {
        dispatch( addAudiences(false) );
        showForm();
    }
}

const addAudiences = isEdit => ({
    type: ADD_AUDIENCES,
    payload: isEdit
});



//AGENDATE AUDIENCE
export function agendateAudiencesAction(audience, data, handleClose, isManual) {
    return async (dispatch) => {
        dispatch( agendateAudiences() );
        try
        {   WaitingMessage('Guardando agendamiento');
            data.enviarEnlace = parseInt(data.enviarEnlace);
            const response = await clienteAxios.post(`/agendar-audiencia${isManual ? '-manual' : ''}/${audience.id}`, data);
            dispatch( agendateAudiencesSuccess(response.data) );
            handleClose();
            Swal.close();
            SuccessMessage(MSG_AGENDATE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( agendateAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const agendateAudiences = () => ({
    type: AGENDATE_AUDIENCES,
    payload: true
});

const agendateAudiencesSuccess = audience => ({
    type: AGENDATE_AUDIENCES_SUCCESS,
    payload: audience
});

const agendateAudiencesError = error => ({
    type: AGENDATE_AUDIENCES_ERROR,
    payload: error
});



//ROLLBACK AUDIENCE
export function rollbackAudienceAction(audience, data, handleClose) {
    return async (dispatch) => {
        dispatch( rollbackAudience() );
        try
        {   WaitingMessage('Cambiando estado');
            const response = await clienteAxios.put(`/audiencia/rollback-finalizada/${audience.id}`, data);
            dispatch( rollbackAudienceSuccess(response.data) );
            handleClose();
            Swal.close();
            SuccessMessage(MSG_AGENDATE_SUCCESS);
            window.location.reload();
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( rollbackAudienceError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const rollbackAudience = () => ({
    type: ROLLBACK_AUDIENCE,
    payload: true
});

const rollbackAudienceSuccess = audience => ({
    type: ROLLBACK_AUDIENCE_SUCCESS,
    payload: audience
});

const rollbackAudienceError = error => ({
    type: ROLLBACK_AUDIENCE_ERROR,
    payload: error
});



//AGENDATE INTERVEENING AUDIENCE
export function agendateIntAudiencesAction(audience, data, handleClose, type) {
    return async (dispatch) => {
        dispatch( agendateIntAudiences() );
        //Verifico el tipo
        if(type === JUDGE_INTERVEENING || type === JUDGE_FIXED){
            try
            {   WaitingMessage('Guardando agendamiento');
                //Por defecto es fijo
                let url = '/agendar-audiencia-fija';
                //Me fijo el tipo
                if(type === JUDGE_INTERVEENING){
                    url = '/agendar-audiencia-interviniente';
                }
                //Hago la consulta (Si es manual cambia la URL)
                const response = await clienteAxios.post(`${url}/${audience.id}`, data);
                dispatch( agendateIntAudiencesSuccess(response.data) );
                handleClose();
                Swal.close();
                SuccessMessage(MSG_AGENDATE_SUCCESS);
            }
            catch(error)
            {   const response = error.response;
                let data = {
                    data: null,
                    message: MSG_ERROR_SERVER
                };
                if(response)
                {   data = response.data;
                }
                dispatch( agendateIntAudiencesError(data) );
                Swal.close();
                ErrorMessageWithAction({
                    text: data.message
                },() => {
                    //Acutalizo
                    window.location.reload();
                });
            }
        }
        else
        {   let data = {
                data: null,
                message: MSG_ERROR_AGENDATE_TYPE
            };
            dispatch( agendateIntAudiencesError(data) );
            ErrorMessage(data.message);
        }
    }
}

const agendateIntAudiences = () => ({
    type: AGENDATE_AUDIENCES,
    payload: true
});

const agendateIntAudiencesSuccess = audience => ({
    type: AGENDATE_AUDIENCES_SUCCESS,
    payload: audience
});

const agendateIntAudiencesError = error => ({
    type: AGENDATE_AUDIENCES_ERROR,
    payload: error
});



//ANULATE AUDIENCE
export function anulateAudienceAction(audience) {
    return async (dispatch) => {
        dispatch( anulateAudience() );
        try
        {   WaitingMessage('Anulando solicitud')
            const response = await clienteAxios.put(`/${controller}/${audience.id}/anular`);
            dispatch( anulateAudienceSuccess(response.data) );
            Swal.close();
            SuccessMessage(MSG_ANULATE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( anulateAudienceError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const anulateAudience = () => ({
    type: ANULATE_AUDIENCE,
    payload: true
});


const anulateAudienceSuccess = audience => ({
    type: ANULATE_AUDIENCE_SUCCESS,
    payload: audience
});

const anulateAudienceError = error => ({
    type: ANULATE_AUDIENCE_ERROR,
    payload: error
});



//ANULATE AUDIENCE
export function anulateAccusedResultAction(audience, accused) {
    return async (dispatch) => {
        dispatch( anulateAccusedResult() );
        try
        {   const response = await clienteAxios.put(`/imputado/delete-resultado/${accused.id}`);
            if(response.status===200)
            {   // Actualiza el state
                dispatch( anulateAccusedResultSuccess(audience) );
                Swal.close();
                SuccessMessage(MSG_ANULATE_ACCUSED_RESULT_SUCCESS);
            }
            else
            {   ErrorMessage(MSG_ERROR_SERVER);  
            }
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( anulateAccusedResultError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const anulateAccusedResult = () => ({
    type: ANULATE_ACCUSED_RESULT,
    payload: true
});

const anulateAccusedResultSuccess = audience => ({
    type: ANULATE_ACCUSED_RESULT_SUCCESS,
    payload: audience
});

const anulateAccusedResultError = error => ({
    type: ANULATE_ACCUSED_RESULT_ERROR,
    payload: error
});



//APPROVE AUDIENCE
export function approveAudiencesAction(audience) {
    return async (dispatch) => {
        dispatch( approveAudiences() );
        try
        {   WaitingMessage('Aprobando solicitud');
            const response = await clienteAxios.put(`/${controller}/${audience.id}/aprobar`);
            dispatch( approveAudiencesSuccess(response.data) );
            Swal.close();
            SuccessMessage(MSG_APPROVE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( approveAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const approveAudiences = () => ({
    type: APPROVE_AUDIENCE,
    payload: true
});

const approveAudiencesSuccess = audience => ({
    type: APPROVE_AUDIENCE_SUCCESS,
    payload: audience
});

const approveAudiencesError = error => ({
    type: APPROVE_AUDIENCE_ERROR,
    payload: error
});



//CANCEL AUDIENCE
export function cancelAudiencesAction(audience, data) {
    return async (dispatch) => {
        dispatch( cancelAudiences() );
        try
        {   WaitingMessage('Cancelando audiencia');
            const response = await clienteAxios.put(`/${controller}/cancelar`, data);
            dispatch( cancelAudiencesSuccess(response.data) );
            Swal.close();
            SuccessMessage(MSG_CANCEL_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( cancelAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const cancelAudiences = () => ({
    type: CANCEL_AUDIENCE,
    payload: true
});

const cancelAudiencesSuccess = audience => ({
    type: CANCEL_AUDIENCE_SUCCESS,
    payload: audience
});

const cancelAudiencesError = error => ({
    type: CANCEL_AUDIENCE_ERROR,
    payload: error
});



//CLONE AUDIENCE
export function cloneAudienceAction(audience,data,handleClose) {
    return async (dispatch) => {
        dispatch( cloneAudience() );
        try
        {   handleClose();
            WaitingMessage('Duplicando audiencia');
            const response = await clienteAxios.post(`/${controller}/${audience.id}/clonar`,data);
            dispatch( cloneAudienceSuccess(response.data) );
            Swal.close();
            window.location.reload();
            SuccessMessage(MSG_CLONE_AUDIENCE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( cloneAudienceError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const cloneAudience = () => ({
    type: CLONE_AUDIENCE,
    payload: true
});

const cloneAudienceSuccess = audience => ({
    type: CLONE_AUDIENCE_SUCCESS,
    payload: audience
});

const cloneAudienceError = error => ({
    type: CLONE_AUDIENCE_ERROR,
    payload: error
});



//DELETE AUDIENCE
export function deleteAudiencesAction(audience) {
    return async (dispatch) => {
        dispatch( deleteAudiences() );
        WaitingMessage(MSG_DELETING);
        try
        {   const response = await clienteAxios.delete(`/${controller}/${audience.id}`);
            dispatch( deleteAudiencesSuccess(audience.id) );
            Swal.close();
            SuccessMessage(MSG_DELETE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( deleteAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const deleteAudiences = () => ({
    type: DELETE_AUDIENCES,
    payload: true
});

const deleteAudiencesSuccess = audience => ({
    type: DELETE_AUDIENCES_SUCCESS,
    payload: audience
});

const deleteAudiencesError = error => ({
    type: DELETE_AUDIENCES_ERROR,
    payload: error
});



//EDIT AUDIENCE
export function editAudiencesAction(audience, showForm) {
    return async (dispatch) => {
        dispatch( editAudiences(audience) );
        showForm();
    }
}

const editAudiences = audience => ({
    type: EDIT_AUDIENCES,
    payload: audience
});



//FINALIZE AUDIENCE
export function finalizeAudienceAction(data, handleClose) {
    return async (dispatch) => {
        dispatch( finalizeAudience() );
        try
        {   const response = await clienteAxios.post(`/${controller}/audiencia-resultado`, data);
            dispatch( finalizeAudienceSuccess(response.data) );
            handleClose();
            Swal.close();
            SuccessMessage(MSG_FINALIZE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( finalizeAudienceError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const finalizeAudience = () => ({
    type: FINALIZE_AUDIENCE,
    payload: true
});

const finalizeAudienceSuccess = audience => ({
    type: FINALIZE_AUDIENCE_SUCCESS,
    payload: audience
});

const finalizeAudienceError = error => ({
    type: FINALIZE_AUDIENCE_ERROR,
    payload: error
});



//GET AUDIENCES
export function getAudiencesAction(audienceId, user) {
    return async (dispatch) => {
        dispatch( getAudiences() );
        WaitingMessage('Cargando datos de Audiencia');
        try
        {   //En base al perfil debo usar uno u otro método
            let methodSuffix = '/dto';
            //En base al perfil debo cambiar método
            if(user.perfil.id === PROFILE_SISTEMAS || user.perfil.id === PROFILE_OGA){
                //Es otro el método
                methodSuffix = '/dto';
            }
            const response = await clienteAxios.get(`/${controller}${methodSuffix}/${audienceId}`);
            let audience = response.data;
            //Busco los jueces que intervinieron
            const responseJudges = await clienteAxios.get(`/${controller}/${audienceId}/jueces-intervinientes-min`);
            //Ordeno los Jueces Seleccionados por id
            audience.audienciaJuezList.sort( (a,b)=>{
                if (a.id > b.id)  return 1;
                if (a.id < b.id)  return -1;
                return 0;
            } );
            //Asigno los jueces
            audience = {
                ...audience,
                judges: responseJudges.data
            }
            dispatch( getAudiencesSuccess(audience) );
            Swal.close();
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( getAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const getAudiences = () => ({
    type: GET_AUDIENCE,
    payload: true
});

const getAudiencesSuccess = audience => ({
    type: GET_AUDIENCE_SUCCESS,
    payload: audience
});

const getAudiencesError = error => ({
    type: GET_AUDIENCE_ERROR,
    payload: error
});



//LISTAR AUDIENCES
export function listAudiencesAction(params) {
    return async (dispatch) => {
        dispatch( listAudiences() );
        WaitingMessage('Cargando audiencias');
        try
        {   const response = await clienteAxios.get(`${process.env.REACT_APP_BACKEND_URL_V2}/audiences`, { params });
            dispatch( listAudiencesSuccess(response.data) );
            Swal.close();
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( listAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const listAudiences = () => ({
    type: LIST_AUDIENCES,
    payload: true
});

const listAudiencesSuccess = audiences => ({
    type: LIST_AUDIENCES_SUCCESS,
    payload: audiences
});

const listAudiencesError = error => ({
    type: LIST_AUDIENCES_ERROR,
    payload: error
});



//REJECT AUDIENCE
export function rejectAudiencesAction(audience, data) {
    return async (dispatch) => {
        dispatch( rejectAudiences() );
        try
        {   WaitingMessage('Rechazando solicitud');
            const response = await clienteAxios.put(`/${controller}/rechazar`, data);
            dispatch( rejectAudiencesSuccess(response.data) );
            Swal.close();
            SuccessMessage(MSG_REJECT_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( rejectAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const rejectAudiences = () => ({
    type: REJECT_AUDIENCE,
    payload: true
});

const rejectAudiencesSuccess = audience => ({
    type: REJECT_AUDIENCE_SUCCESS,
    payload: audience
});

const rejectAudiencesError = error => ({
    type: REJECT_AUDIENCE_ERROR,
    payload: error
});



//RESERVE AUDIENCE
export function reserveAudiencesAction(audience, isReserva) {
    return async (dispatch) => {
        dispatch( reserveAudiences() );
        try
        {   const actionText = isReserva === 1 ? 'Reservando' : 'Quitando reserva de';
            WaitingMessage(`${actionText} audiencia`);
            const response = await clienteAxios.put(`/${controller}/${audience.id}/reservar/${isReserva}`);
            dispatch( reserveAudiencesSuccess(response.data) );
            Swal.close();
            SuccessMessage(isReserva === 1 ? MSG_RESERVE_SUCCESS : MSG_UNRESERVE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( reserveAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const reserveAudiences = () => ({
    type: RESERVE_AUDIENCE,
    payload: true
});

const reserveAudiencesSuccess = audience => ({
    type: RESERVE_AUDIENCE_SUCCESS,
    payload: audience
});

const reserveAudiencesError = error => ({
    type: RESERVE_AUDIENCE_ERROR,
    payload: error
});



//REVOKE AUDIENCE
export function revokeAudiencesAction(audience, data) {
    return async (dispatch) => {
        dispatch( revokeAudiences() );
        try
        {   WaitingMessage('Revocando audiencia');
            const response = await clienteAxios.put(`/${controller}/revocar`, data);
            dispatch( revokeAudiencesSuccess(response.data) );
            Swal.close();
            SuccessMessage(MSG_REVOKE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( revokeAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const revokeAudiences = () => ({
    type: REVOKE_AUDIENCE,
    payload: true
});

const revokeAudiencesSuccess = audience => ({
    type: REVOKE_AUDIENCE_SUCCESS,
    payload: audience
});

const revokeAudiencesError = error => ({
    type: REVOKE_AUDIENCE_ERROR,
    payload: error
});



//SAVE AUDIENCE
export function saveAudiencesAction(audience, history) {
    return async (dispatch) => {
        dispatch( saveAudiences() );
        try
        {   WaitingMessage('Guardando solicitud');
            const response = await clienteAxios.post(`/${controller}/solicitud-audiencia`, audience);
            dispatch( saveAudiencesSuccess(response.data) );
            Swal.close();
            SuccessMessage(MSG_CREATE_SUCCESS);
            history.push(`/audiencias/${response.data.id}/formulario-trabajo/informacion`);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( saveAudiencesError(data) );
            Swal.close();
            ErrorMessage(data.message);
        }
    }
}

const saveAudiences = () => ({
    type: SAVE_AUDIENCES,
    payload: true
});

const saveAudiencesSuccess = audience => ({
    type: SAVE_AUDIENCES_SUCCESS,
    payload: audience
});

const saveAudiencesError = error => ({
    type: SAVE_AUDIENCES_ERROR,
    payload: error
});



//SAVE IMPUTADO RESULT
export function saveAccusedResultAction(data) {
    return async (dispatch) => {
        dispatch( saveAccusedResult() );
        try
        {   const response = await clienteAxios.post(`/${controller}/imputado-resultado`, data);
            dispatch( saveAccusedResultSuccess(response.data) );
            SuccessMessage(MSG_SAVE_ACCUSED_RESULT_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( saveAccusedResultError(data) );
            ErrorMessage(data.message);
        }
    }
}

const saveAccusedResult = () => ({
    type: SAVE_ACCUSED_RESULT,
    payload: true
});

const saveAccusedResultSuccess = audience => ({
    type: SAVE_ACCUSED_RESULT_SUCCESS,
    payload: audience
});

const saveAccusedResultError = error => ({
    type: SAVE_ACCUSED_RESULT_ERROR,
    payload: error
});



//UPDATE ACCUSED
export function updateAccusedAction(accused, data, handleClose) {
    return async (dispatch) => {
        dispatch( updateAccused() );
        try
        {   const response = await clienteAxios.put(`/${controller}/${accused.id}/imputado`, data);
            dispatch( updateAccusedSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_ACCUSED_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateAccusedError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateAccused = () => ({
    type: UPDATE_ACCUSED,
    payload: true
});

const updateAccusedSuccess = audience => ({
    type: UPDATE_ACCUSED_SUCCESS,
    payload: audience
});

const updateAccusedError = error => ({
    type: UPDATE_ACCUSED_ERROR,
    payload: error
});



//UPDATE AUDIENCE
export function updateAudiencesAction(audience, handleClose) {
    return async (dispatch) => {
        dispatch( updateAudiences() );
        try
        {   const response = await clienteAxios.put(`/${controller}/${audience.id}`, audience);
            dispatch( updateAudiencesSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateAudiencesError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateAudiences = () => ({
    type: UPDATE_AUDIENCES,
    payload: true
});

const updateAudiencesSuccess = audience => ({
    type: UPDATE_AUDIENCES_SUCCESS,
    payload: audience
});

const updateAudiencesError = error => ({
    type: UPDATE_AUDIENCES_ERROR,
    payload: error
});


//UPDATE CANCELLATION
export function updateCancellationAction(audience, data, handleClose) {
    return async (dispatch) => {
        dispatch( updateCancellation() );
        try
        {   const response = await clienteAxios.put(`/${controller}/modificar-cancelacion/${audience.id}`, data);
            dispatch( updateCancellationSuccess(response.data) );
            SuccessMessage(MSG_UPDATE_SUCCESS);
            handleClose();
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateCancellationError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateCancellation = () => ({
    type: UPDATE_CANCELLATION,
    payload: true
});

const updateCancellationSuccess = audience => ({
    type: UPDATE_CANCELLATION_SUCCESS,
    payload: audience
});

const updateCancellationError = error => ({
    type: UPDATE_CANCELLATION_ERROR,
    payload: error
});



//UPDATE FISCAL
export function updateProsecutorAction(audience, data, handleClose) {
    return async (dispatch) => {
        dispatch( updateProsecutor() );
        try
        {   const response = await clienteAxios.put(`/${controller}/${audience.id}/fiscal/${data.fiscalId}/fiscalia/${data.fiscaliaId}`);
            dispatch( updateProsecutorSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_PROSECUTOR_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateProsecutorError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateProsecutor = () => ({
    type: UPDATE_PROSECUTOR,
    payload: true
});

const updateProsecutorSuccess = audience => ({
    type: UPDATE_PROSECUTOR_SUCCESS,
    payload: audience
});

const updateProsecutorError = error => ({
    type: UPDATE_PROSECUTOR_ERROR,
    payload: error
});



//UPDATE OFIJU
export function updateOfijuAction(audience, data, handleClose) {
    return async (dispatch) => {
        dispatch( updateOfiju() );
        try
        {   const response = await clienteAxios.put(`/${controller}/${audience.id}/ofiju/${data.ofijuId}`);
            dispatch( updateOfijuSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_OFIJU_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateOfijuError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateOfiju = () => ({
    type: UPDATE_OFIJU,
    payload: true
});

const updateOfijuSuccess = audience => ({
    type: UPDATE_OFIJU_SUCCESS,
    payload: audience
});

const updateOfijuError = error => ({
    type: UPDATE_OFIJU_ERROR,
    payload: error
});



//UPDATE OPERADOR
export function updateOperatorAction(audience, data, handleClose) {
    return async (dispatch) => {
        dispatch( updateOperator() );
        try
        {   const response = await clienteAxios.put(`/${controller}/${audience.id}/update-operador`, data);
            dispatch( updateOperatorSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_OPERATOR_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateOperatorError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateOperator = () => ({
    type: UPDATE_OPERATOR,
    payload: true
});

const updateOperatorSuccess = audience => ({
    type: UPDATE_OPERATOR_SUCCESS,
    payload: audience
});

const updateOperatorError = error => ({
    type: UPDATE_OPERATOR_ERROR,
    payload: error
});



//UPDATE PROCEEDING
export function updateProceedingAction(audience, data, handleClose) {
    return async (dispatch) => {
        dispatch( updateProceeding() );
        try
        {   const response = await clienteAxios.put(`/${controller}/${audience.id}/expediente`, data);
            dispatch( updateProceedingSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_PROCEEDING_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateProceedingError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateProceeding = () => ({
    type: UPDATE_PROCEEDING,
    payload: true
});

const updateProceedingSuccess = audience => ({
    type: UPDATE_PROCEEDING_SUCCESS,
    payload: audience
});

const updateProceedingError = error => ({
    type: UPDATE_PROCEEDING_ERROR,
    payload: error
});



//UPDATE SALA
export function updateSalaAction(audience, data, handleClose) 
{   return async (dispatch) => {
        dispatch( updateSala() );
        try
        {   const response = await clienteAxios.put(`/${controller}/${audience.id}/update-sala`, data);
            dispatch( updateSalaSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_SALA_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateSalaError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateSala = () => ({
    type: UPDATE_SALA,
    payload: true
});

const updateSalaSuccess = audience => ({
    type: UPDATE_SALA_SUCCESS,
    payload: audience
});

const updateSalaError = error => ({
    type: UPDATE_SALA_ERROR,
    payload: error
});



//UPDATE SCHEDULED END
export function updateScheduledEndAction(audience, data, handleClose) 
{   return async (dispatch) => {
        dispatch( updateScheduledEnd() );
        try
        {   const response = await clienteAxios.put(`/${controller}/${audience.id}/update-horario-programado`, data);
            dispatch( updateScheduledEndSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_SCHEDULED_END_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateScheduledEndError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateScheduledEnd = () => ({
    type: UPDATE_SCHEDULED_END,
    payload: true
});

const updateScheduledEndSuccess = audience => ({
    type: UPDATE_SCHEDULED_END_SUCCESS,
    payload: audience
});

const updateScheduledEndError = error => ({
    type: UPDATE_SCHEDULED_END_ERROR,
    payload: error
});



//UPDATE SESSION
export function updateSessionUrlAction(audience, data, handleClose) {
    return async (dispatch) => {
        dispatch( updateSessionUrl() );
        try
        {   const response = await clienteAxios.put(`/grabacion/set-session/${audience.id}`, data);
            dispatch( updateSessionUrlSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_SESSION_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateSessionUrlError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateSessionUrl = () => ({
    type: UPDATE_SESSION_URL,
    payload: true
});

const updateSessionUrlSuccess = audience => ({
    type: UPDATE_SESSION_URL_SUCCESS,
    payload: audience
});

const updateSessionUrlError = error => ({
    type: UPDATE_SESSION_URL_ERROR,
    payload: error
});



//UPDATE VICTIM
export function updateVictimAction(victim, data, handleClose) {
    return async (dispatch) => {
        dispatch( updateVictim() );
        try
        {   const response = await clienteAxios.put(`/${controller}/${victim.id}/victima`, data);
            dispatch( updateVictimSuccess(response.data) );
            handleClose();
            SuccessMessage(MSG_UPDATE_VICTIM_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            if(response)
            {   data = response.data;
            }
            dispatch( updateVictimError(data) );
            ErrorMessage(data.message);
        }
    }
}

const updateVictim = () => ({
    type: UPDATE_VICTIM,
    payload: true
});

const updateVictimSuccess = audience => ({
    type: UPDATE_VICTIM_SUCCESS,
    payload: audience
});

const updateVictimError = error => ({
    type: UPDATE_VICTIM_ERROR,
    payload: error
});



//WORK LIST AUDIENCES
export function listWorkListAction(params = {}) {
    return async dispatch => {
        dispatch(listWorkList());
        WaitingMessage('Cargando solicitudes');

        try {
            const {
                page = 0,
                size = 20,
            } = params;

            // NUEVO
            const response = await clienteAxios.get(`${process.env.REACT_APP_BACKEND_URL_V2}/${controllerV2}/work-list`, {
                params: {
                    page,
                    size
                }
            });
            const audiences = response.data.content;
            const isFirst = page === 0;
            const isLast = response.data.total_pages === (page+1);
            const totalElements = response.data.total_elements;
            const totalPages = response.data.total_pages;

            dispatch(
                listWorkListSuccess({
                    audiences,
                    isFirst,
                    isLast,
                    page,
                    totalPages,
                    totalElements
                })
            );

            Swal.close();
        } catch (error) {
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER,
            };
            if (response) {
                data = response.data;
            }
            dispatch(listWorkListError(data));
            Swal.close();
            ErrorMessage(data.message);
        }
    };
}
const listWorkList = () => ({
    type: WORK_LIST_AUDIENCES,
    payload: true
});
const listWorkListSuccess = data => ({
    type: WORK_LIST_AUDIENCES_SUCCESS,
    payload: data
});
const listWorkListError = error => ({
    type: WORK_LIST_AUDIENCES_ERROR,
    payload: error
});